var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOneDrive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1127.2 214.7",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: #094ab1;\r\n        stroke-width: 0px;\r\n      }\r\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "svg2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "layer1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g3986"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path4256",
    className: "cls-1",
    d: "M124,196.6c-18.5-4.6-28.8-19.3-28.8-41.1,0-7,.5-10.3,2.2-14.8,4.3-11,15.6-19.3,30.4-22.3,7.4-1.5,9.7-3.1,9.7-6.9s.9-4.7,2-7.8c4.9-14.2,13.9-26,23.6-30.9,10.1-5.1,15.2-6.2,27.5-6.1,17.4,0,26,3.9,38.2,16.6l6.7,7,6-2.1c28.9-10,57.7,7,60.1,35.5l.6,7.8,5.7,2c16.3,5.8,23.9,18.1,22.5,36-.9,11.8-6.4,21.1-15.1,25.8l-4.1,2.2-91,.2c-69.9.1-92.2-.1-96-1.1h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4248",
    className: "cls-1",
    d: "M55.8,184c-10.8-2.6-22.2-12.1-27.6-23-3-6.2-3.2-7.1-3.2-18s.3-12.1,2.7-17.2c5.1-10.9,14.9-18.8,27.1-21.8,2.6-.7,5-1.7,5.4-2.3.4-.6.8-4,.9-7.5.9-21.8,15.1-41,35.1-47.1,10.8-3.3,24.3-2.5,36.1,2.2,3.7,1.5,3.3,1.8,11.2-8.5,4.7-6.1,14-13.7,21.7-17.5,8.3-4.2,16.9-6.1,27.3-6.1,28.9,0,53.7,18.1,62.9,45.7,2.9,8.8,2.8,11.3-.7,11.3-1.5,0-5.8.9-9.6,1.9l-6.9,1.8-6.3-6.3c-17.7-17.7-46.6-21.5-71.2-9.4-9.8,4.8-17.7,11.8-23.7,20.8-4.2,6.5-9.7,18.5-9.7,21.5s-1.7,3.2-9,5.6c-22.7,7.4-35.9,24.6-35.9,46.6,0,8,2.1,17.8,4.9,23.4,1.1,2.1,1.7,4.1,1.3,4.5-.9.9-29.1.6-33-.3h0Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "text3027"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3010",
    className: "cls-1",
    d: "M432.2,178.7c-17.9,0-32.2-5.9-42.9-17.7-10.8-11.8-16.1-27.1-16.1-46,0-20.3,5.5-36.4,16.4-48.5,11-12.1,25.9-18.1,44.7-18.1,17.4,0,31.4,5.9,42.1,17.6,10.6,11.7,16,27,16,46,0,20.6-5.4,36.8-16.3,48.8-10.9,12-25.5,17.9-43.8,17.9ZM433.2,61.8c-13.2,0-24,4.8-32.3,14.3-8.3,9.6-12.4,22.1-12.4,37.6,0,15.5,4,28,12.1,37.5,8.1,9.5,18.6,14.2,31.5,14.2s24.7-4.5,32.7-13.5c8-9,12-21.7,12-37.9,0-16.6-3.9-29.5-11.6-38.6-7.7-9.1-18.4-13.6-32-13.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3012",
    className: "cls-1",
    d: "M589.9,176.6h-14.4v-51.3c0-19.1-7-28.7-20.9-28.7-7.2,0-13.2,2.7-17.9,8.1-4.7,5.4-7.1,12.3-7.1,20.5v51.3h-14.4v-90h14.4v14.9h.4c6.8-11.4,16.6-17.1,29.5-17.1,9.8,0,17.4,3.2,22.6,9.5,5.2,6.4,7.8,15.5,7.8,27.6v55Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3014",
    className: "cls-1",
    d: "M689.4,135.2h-63.5c.2,10,2.9,17.8,8.1,23.2,5.2,5.4,12.2,8.2,21.3,8.2s19.5-3.3,27.9-10v13.5c-7.9,5.7-18.4,8.6-31.4,8.6s-22.7-4.1-30-12.3c-7.3-8.2-10.9-19.7-10.9-34.5,0-14,4-25.4,11.9-34.2,7.9-8.8,17.8-13.2,29.6-13.2,11.8,0,20.9,3.8,27.3,11.4,6.4,7.6,9.7,18.2,9.7,31.7v7.6ZM674.7,123c0-8.3-2.1-14.8-6-19.4-4-4.6-9.4-6.9-16.5-6.9-6.8,0-12.6,2.4-17.3,7.3-4.7,4.9-7.7,11.2-8.8,19.1h48.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3016",
    className: "cls-1",
    d: "M713.3,176.6V50.6h34.8c44.4,0,66.6,20.5,66.6,61.4,0,19.5-6.2,35.1-18.5,46.9-12.3,11.8-28.8,17.7-49.5,17.7h-33.4ZM728,63.9v99.3h18.8c16.5,0,29.4-4.4,38.6-13.3,9.2-8.8,13.8-21.4,13.8-37.6,0-32.3-17.2-48.4-51.5-48.4h-19.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3018",
    className: "cls-1",
    d: "M884.5,101.2c-2.5-1.9-6.2-2.9-10.9-2.9-6.2,0-11.3,2.9-15.4,8.7-4.1,5.8-6.2,13.7-6.2,23.7v45.9h-14.4v-90h14.4v18.5h.4c2.1-6.3,5.2-11.3,9.4-14.8,4.2-3.5,8.9-5.3,14.2-5.3,3.7,0,6.6.4,8.6,1.2v14.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3020",
    className: "cls-1",
    d: "M907.5,63.8c-2.6,0-4.8-.9-6.6-2.6-1.8-1.8-2.7-4-2.7-6.7,0-2.7.9-4.9,2.7-6.7,1.8-1.8,4-2.7,6.6-2.7,2.6,0,4.9.9,6.7,2.7,1.8,1.8,2.8,4,2.8,6.7,0,2.6-.9,4.8-2.8,6.6-1.8,1.8-4.1,2.7-6.7,2.7ZM914.5,176.6h-14.4v-90h14.4v90Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3022",
    className: "cls-1",
    d: "M1014.5,86.6l-35.9,90h-14.2l-34.1-90h15.8l22.9,65.4c1.7,4.8,2.8,9,3.2,12.6h.4c.6-4.5,1.5-8.6,2.8-12.2l23.9-65.7h15.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3024",
    className: "cls-1",
    d: "M1102.2,135.2h-63.5c.2,10,2.9,17.8,8.1,23.2,5.2,5.4,12.2,8.2,21.3,8.2s19.5-3.3,27.9-10v13.5c-7.9,5.7-18.4,8.6-31.4,8.6s-22.7-4.1-30-12.3c-7.3-8.2-10.9-19.7-10.9-34.5s4-25.4,11.9-34.2c7.9-8.8,17.8-13.2,29.6-13.2,11.8,0,20.9,3.8,27.3,11.4,6.4,7.6,9.7,18.2,9.7,31.7v7.6ZM1087.4,123c0-8.3-2.1-14.8-6-19.4-4-4.6-9.4-6.9-16.5-6.9-6.8,0-12.6,2.4-17.3,7.3-4.7,4.9-7.7,11.2-8.8,19.1h48.6Z"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOneDrive);
export default __webpack_public_path__ + "static/media/one-drive.d9e30a1b49c5b0d94ea4b2745e20224b.svg";
export { ForwardRef as ReactComponent };